import { defineStore } from 'pinia'
import { FormDataType, GameRoleItemType, ILoginType } from '@/@types/types'
import { GameSubItemType } from '@/api/types/gameTypes'
import { PayListType } from '@/views/mall/payGoods/types'

export const useAuthStore = defineStore('__hero_mall_auth__', {
  state: () => ({
    verifyAuthVisible: false,

    isShowMoreDrawer: false,
    isFromCard: false,
    // 礼包弹窗
    isShowGiftDrawer: false,

    formData: {} as FormDataType,
    verifyRole: {} as GameRoleItemType,
    // 当前角色小号列表
    subList: [] as GameSubItemType[],
    // 当前小号
    currentSub: {} as GameSubItemType,
    verifyRoleList: [] as GameRoleItemType[],

    payTypeList: [] as PayListType[],
    hPayTypeList: [] as PayListType[],
    currentPayType: 0 as number,
    // 支付方式的支付折扣 100等于没有折扣
    currentPayRate: 100 as number,
    isChecked: false as boolean,
    // 当前角色反查的账号角色列表
    currentRoleList: [] as any[],

    // phone: 手机登录, verify: 验证码登录, autoVerify: 自动登录
    loginType: 'verify' as ILoginType,

    // 是否同意协议
    agrVisible: false as boolean
  }),
  getters: {
    // 小号列表大于一条，显示切换按钮
    visibleSwitchSubBtn: state => state.subList.length > 1,
    //   获取当前小号列表
    currentSubItem: state => {
      return state.subList.find(item => item.cpUid === state.verifyRole.cpUid)
    }
  },
  actions: {
    setAuthVisible(verifyAuthVisible: boolean) {
      console.log('this.isShowGiftDrawer', this.isShowGiftDrawer)
      // 弹登录窗的时候多一层判断，如果打开了礼包弹窗，就先不弹登录窗
      if (this.isShowGiftDrawer) {
        return
      }
      console.log('verifyAuthVisible', verifyAuthVisible)
      this.verifyAuthVisible = verifyAuthVisible
    },
    // 设置礼包领取提醒弹窗
    setGiftVisible(visible: boolean) {
      if (visible) {
        // 关闭登录弹窗
        this.verifyAuthVisible = false
      }

      this.isShowGiftDrawer = visible
    },
    setIsShowMoreDrawer(visible: boolean) {
      this.isShowMoreDrawer = visible
    },
    setVerifyRole(data: GameRoleItemType) {
      this.verifyRole = data
    },
    setFormData(data: FormDataType) {
      this.formData = data
    },
    setRoleList(data: any[]) {
      this.currentRoleList = data
    }
  },
  persist: {
    key: '__hero_mall_auth__',
    storage: localStorage,
    paths: ['loginType']
  }
})
